import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

const Backend = () => import('@/components/Backend')
const BooteekConnected = () => import('@/components/BooteekConnected')
const Collaborator = () => import('@/components/Collaborator')
const CollageEditor = () => import('@/components/CollageEditor')
const Dashboard = () => import('@/components/Dashboard')
const Funds = () => import('@/components/Funds')
const Help = () => import('@/components/Help')
const Inventory = () => import('@/components/Inventory')
const ExportInventory = () => import('@/components/ExportInventory')
const LandingPage = () => import('@/components/LandingPage')
const Login = () => import('@/components/Login')
const Preview = () => import('@/components/Preview')
const Queue = () => import('@/components/Queue')
const Register = () => import('@/components/Register')
const ReportBug = () => import('@/components/ReportBug')
const SonletConnected = () => import('@/components/SonletConnected')
const Settings = () => import('@/components/Settings')
const TemplateEditor = () => import('@/components/TemplateEditor')
const Terms = () => import('@/components/Terms')
const Upload = () => import('@/components/Upload')
const WholesaleMarketplace = () => import('@/components/WholesaleMarketplace')
const EasterEgg = () => import('@/components/EasterEgg')

Vue.use(Router)

function requireAuth (to, from, next) {
  let user = store.getters.getUser
  let group = store.getters.getGroupId
  window.zzfficient = {
    lastPath: to.path
  }
  if (user && group) {
    next()
  } else {
    next({
      path: '/login',
      query: { redirect: window.zzfficient.lastPath }
    })
  }
}

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/Answer-to-the-Ultimate-Question-of-Life,-the-Universe,-and-Everything/42',
      name: 'EasterEgg',
      component: EasterEgg
    },
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage
    },
    {
      path: '/booteek/:status',
      name: 'BooteekConnected',
      component: BooteekConnected
    },
    {
      path: '/sonlet/:status',
      name: 'SonletConnected',
      component: SonletConnected
    },
    {
      path: '/collaborator/:id',
      name: 'Collaborator',
      component: Collaborator,
      beforeEnter: requireAuth
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/app',
      name: 'Backend',
      component: Backend,
      beforeEnter: requireAuth,
      children: [
        {
          path: ':id',
          component: Dashboard,
          name: 'Dashboard'
        },
        {
          path: ':id/collage',
          component: CollageEditor,
          name: 'CollageEditor'
        },
        {
          path: ':id/funds',
          component: Funds,
          name: 'Funds'
        },
        {
          path: ':id/help',
          component: Help,
          name: 'Help'
        },
        {
          path: ':id/manage-existing',
          component: Inventory,
          name: 'Inventory'
        },
        {
          path: ':id/collage-exports',
          component: ExportInventory,
          name: 'CollageExports'
        },
        {
          path: ':id/crop-preview',
          component: Preview,
          name: 'Preview'
        },
        {
          path: ':id/queue',
          component: Queue,
          name: 'Queue'
        },
        {
          path: ':id/report-bug',
          component: ReportBug,
          name: 'ReportBug'
        },
        {
          path: ':id/settings',
          component: Settings,
          name: 'Settings'
        },
        {
          path: ':id/editor',
          component: TemplateEditor,
          name: 'TemplateEditor'
        },
        {
          path: ':id/upload',
          component: Upload,
          name: 'Upload'
        },
        {
          path: ':id/wholesale-marketplace',
          component: WholesaleMarketplace,
          name: 'WholesaleMarketplace'
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js